import React from 'react';
import Header from '../components/Header';
import BookRide from '../components/BookRide';
import Footer from '../components/Footer';
import './About.css';

const pub = process.env.PUBLIC_URL;

const pillars = [
  { icon: 'idea-4-1.png', title: 'Innovation' },
  { icon: 'diamond-1.png', title: 'Durability' },
  { icon: 'leaf-1.png', title: 'Customer-Centricity' },
  { icon: 'crown-1-1.png', title: 'Quality' },
];

const visionPoints = [
  'Utility Task Vehicles for specialized commercial use.',
  'Armored Task Vehicles for defense and security operations.',
  'Autonomous Robotic Vehicles for cutting-edge applications.',
];

const journey = [
  {
    title: 'Our Team',
    text: 'A dynamic blend of experts in design, engineering, and technology, all united by a passion for innovation. Through rigorous trials and real-world testing in challenging conditions, we embraced each difficulty as a chance to learn and evolve.',
  },
  {
    title: 'Relentless Refinement',
    text: 'Through relentless testing, redesigning, and refining, our team continuously improves every aspect of our vehicles, ensuring they meet the highest standards and exceed customer expectations.',
  },
  {
    title: 'National Pride',
    text: "We aim to contribute significantly to India's automotive industry, leveraging advanced technology and local manufacturing to set new benchmarks. Our products are designed not just to meet market demands but to push boundaries, bringing innovation and national pride to the forefront.",
  },
];

const choosePoints = [
  'Uncompromising quality backed by robust testing and precision engineering.',
  'Vehicles that deliver superior performance across diverse terrains.',
  'A commitment to sustainability, customer satisfaction, and continuous improvement.',
];

function About() {
  return (
    <div>
      <Header />

      {/* ── Hero ── */}
      <section
        className="abt-hero"
        style={{ backgroundImage: `url(${pub}/about/about-hero.jpg)` }}
      >
        <div className="abt-hero__overlay" />
        <div className="abt-hero__content">
          <h1 className="abt-hero__heading">
            Igniting the Spirit of Adventure:<br />A Journey Like No Other
          </h1>
          <p className="abt-hero__text">
            Welcome to Acriolis India Motors, where ambition meets innovation to redefine the
            automotive landscape. We are not just building vehicles — we are shaping the future
            of mobility with a focus on performance, sustainability, and customer satisfaction.
            Our ATVs and UTVs are engineered for power, durability, and versatility, making
            them the ultimate choice for off-road enthusiasts, defense applications, and
            international markets.
          </p>
          <span className="abt-hero__scroll">Scroll down ↓</span>
        </div>
      </section>

      {/* ── Principles statement ── */}
      <section className="abt-statement">
        <h2 className="abt-statement__text">
          Our success is built on three unwavering principles — Quality, Innovation,
          and Customer Satisfaction.
        </h2>
      </section>

      {/* ── Pillars ── */}
      <section className="abt-pillars">
        <h2 className="abt-pillars__heading">Our Pillars of Excellence</h2>
        <div className="abt-pillars__grid">
          {pillars.map((p) => (
            <div className="abt-pillars__item" key={p.title}>
              <img src={`${pub}/about/${p.icon}`} alt="" className="abt-pillars__icon" />
              <span className="abt-pillars__label">{p.title}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── Journey ── */}
      <section className="abt-journey">
        <h2 className="abt-journey__heading">Our Timeline</h2>
        <div className="abt-journey__grid">
          {journey.map((j) => (
            <div className="abt-journey__card" key={j.title}>
              <h3 className="abt-journey__card-title">{j.title}</h3>
              <p className="abt-journey__card-text">{j.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── Vision ── */}
      <section className="abt-vision">
        <div className="abt-vision__inner">
          <h2 className="abt-vision__heading">Vision for the Future</h2>
          <p className="abt-vision__text">
            Looking to the future, our vision at Acriolis India Motors is to continue
            prioritizing our commitment to serving the country while expanding our impact on
            India's evolving business landscape. Under the clear and strategic guidance of
            Mrs. Darshana Jadon, Company's Owner &amp; Director, we aim to build upon our
            solid foundation by diversifying into new and innovative off-road segments. Our
            vision is bold: To expand our offerings and impact through:
          </p>
          <ul className="abt-vision__list">
            {visionPoints.map((v) => (
              <li key={v} className="abt-vision__list-item">{v}</li>
            ))}
          </ul>

          <h3 className="abt-vision__subheading">
            When you choose Acriolis India Motors, you choose:
          </h3>
          <ul className="abt-vision__list">
            {choosePoints.map((c) => (
              <li key={c} className="abt-vision__list-item">{c}</li>
            ))}
          </ul>
        </div>
      </section>

      <BookRide />
      <Footer />
    </div>
  );
}

export default About;
